import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  overflow: hidden;
`;

export const MainContent = styled.div`
  flex: 1;
  overflow: auto;
  position: relative;
`;

export const ToggleWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

export const ToggleContainer = styled.div`
  padding: 16px;
  border-bottom: 1px solid #e8e8e8;
`;

export const Sidebar = styled.div`
  height: 100%;
  background-color: #fff;
  overflow: hidden;
`;

export const SidebarContent = styled.div`
  height: 100%;
  overflow: hidden;
`;

export const ChatPanelsContainer = styled.div<{ showList: boolean }>`
  display: flex;
  width: 200%;
  height: 100%;
  transition: transform 0.3s ease;
  transform: translateX(${({ showList }) => showList ? '0' : '-50%'});
`;

export const Panel = styled.div`
  width: 50%;
  height: 100%;
  flex-shrink: 0;
`;

export const ChatListHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ChatList = styled.div`
  padding: 16px;
  height: calc(100% - 103px);
  overflow-y: auto;
`;

export const ChatItem = styled.div`
  padding: 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-bottom: 8px;

  &:hover {
    background-color: #f5f5f5;
  }

  h3 {
    margin: 0;
    font-size: 14px;
    color: #000;
  }

  p {
    margin: 4px 0 0;
    font-size: 12px;
    color: #999;
  }
`;

export const FloatingHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 8px;

  h2 {
    margin: 0;
    font-size: 16px;
    flex: 1;
  }
`;
